import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  CardWrapper,
  OverallTeamPosition,
  SeeAllStyledModal,
  CustomTitle,
  TeamCardNew,
  MemberDataV3,
  CaptainLogoV2,
  Heading
} from './style';
import { LeaderboardRow, LeaderboardHeader, UserColumn, AnswerColumn, RankColumn, NewUserName } from '../ChallengeDetailsV2/ChallengeLeaderboardV2/styles';
import isEmpty from 'lodash/isEmpty';
import { ImageUrl } from '../../utils/constants';
import { commaSeperator, rankingDashboard } from '../../utils/methods';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import LazyImage from '../common/LazyImage/LazyImage';
import SkeletonLoder from '../common/skeletonLoder';

const TeamDetailsPopup = React.lazy(() => import('./userTeamDetailsPopup'));

// Styles for Rank Backgrounds 
const RANK_STYLES = {
  1: {
    background: 'linear-gradient(91deg, #B18B28 -38.43%, #F7EF8A 47.91%, #B18B28 134.25%)', // Gold
    color: '#184A61',
    border: '0.75px solid #B18B28'
  },
  2: {
    background: 'linear-gradient(90deg, #9A9DA2 -67.25%, #EDEEF3 51.6%, #9A9DA2 153.3%)', // Silver
    color: '#184A61',
    border: '0.75px solid #9A9DA2'
  },
  3: {
    background: 'linear-gradient(91deg, #9A5426 -51.95%, #EBAB80 57.55%, #9A5426 210.37%)', // Bronze
    color: '#184A61',
    border: '0.75px solid #9A5426'
  },
  default: {
    background: '#FEFEFE',
    color: '#184A61',
    border: '0.75px solid #DCDCDC'
  }
};

class BuddiesData extends Component {
  constructor() {
    super();
    this.state = {
      userData: undefined,
      showTeam: false,
      SeeAll: false,
      userIndex: 0,
      teamName: ''
    }
  }

  fallBack = (e) => {
    e.target.src = '/public/images/defaultProfileImg.png'
  }

  leaderboardLimit = () => {
    const { getTopSocialUsers, getTopFitnessUsers, getTopWellnessUsers, getTopUserTotalPoints, companyId, userLimit, pageNumber, activeBuddiesPoints, updateLimit, getCompanyTotalTeamPoints, getTotalTeamUsersPoints } = this.props;
    updateLimit();
    let pageCount;
    pageCount = pageNumber + 1;

    switch (activeBuddiesPoints) {
    case "1": getTopUserTotalPoints(companyId, pageCount, userLimit); break;
    case "2": getTopFitnessUsers(companyId, pageCount, userLimit); break;
    case "3": getTopSocialUsers(companyId, pageCount, userLimit); break;
    case "4": getTopWellnessUsers(companyId, pageCount, userLimit); break;
    case "9": getCompanyTotalTeamPoints(companyId, pageCount, userLimit); break;
    case "8": getTotalTeamUsersPoints(); break;
    default: break;
    }
  }

  handleSeeAll = (data, tname) => {
    this.setState({ SeeAll: true, userIndex: data, teamName: tname })
  }

  hideSeeAllModal = () => {
    this.setState({ SeeAll: false })
  }

  SeeAllModal = () => {
    const { SeeAll, userIndex, teamName } = this.state;
    const { companyTeamPoints } = this.props;
    return (
      <SeeAllStyledModal show={SeeAll} onHide={this.hideSeeAllModal} dialogClassName="modal-90w">
        <Modal.Header>
          <CustomTitle>
            <div>
              <span>{this.props.t(teamName)} {this.props.t("Members")}</span>
              <span className="closeImage" onClick={this.hideSeeAllModal}>
                <img src='/public/images/new_close_icon.png' alt="close" />
              </span>
            </div>
          </CustomTitle>
        </Modal.Header>
        <Modal.Body>
          {companyTeamPoints[userIndex] && companyTeamPoints[userIndex].team_users.length > 0 ? (
            <TeamCardNew>
              <div className="teamDetails">
                {companyTeamPoints[userIndex].team_users.map((member, index) => (
                  <MemberDataV3 key={index} captain={member.is_captain === 1} border={index === 0}>
                    <div>
                      <div className='imageDiv'>
                        {member.is_captain === 1 && <CaptainLogoV2 src='/public/images/captain-band.png' />}
                        <LazyImage src={`${ImageUrl}/${member.profile_image}`} alt="people_icon" />
                      </div>
                    </div>
                    <div className='textBox'>
                      <div>{index + 1}{rankingDashboard(index)}</div>
                      <h1>{member.fullname}
                        {member.is_captain === 1 && <span className='max'> &nbsp;({this.props.t("Captain")})</span>}
                      </h1>
                    </div>
                    <div className='showpoint'>
                      <div>{member.total_points}</div>
                      <span>{this.props.t("Total Pts")}</span>
                    </div>
                  </MemberDataV3>
                ))}
              </div>
            </TeamCardNew>
          ) : (
            <h3 style={{ color: '#184A61' }}>{this.props.t("No members added to this team")}</h3>
          )}
        </Modal.Body>
      </SeeAllStyledModal>
    );
  }

  onScroll = (e) => {
    const bottom = Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop, 10)) === Math.round(e.target.clientHeight);
    if (bottom) {
      this.leaderboardLimit()
    }
  };

  showTeamDetails = () => {
    this.setState({
      showTeam: !this.state.showTeam
    })
  };

 
  getPointsAndLabel = (data) => {
    const { activeBuddiesPoints, t } = this.props;
    let points = 0;
    let label = "XP"; 

    if (activeBuddiesPoints === "1") { points = data.total_points; label = "XP"; }
    else if (activeBuddiesPoints === "2") { points = data.fitness_points; label = "XP"; }
    else if (activeBuddiesPoints === "3") { points = data.social_points; label = "XP"; }
    else if (activeBuddiesPoints === "4") { points = data.wellness_points; label = "XP"; }
    else if (activeBuddiesPoints === "9") { points = data.total_team_points; label = "XP"; }
    else if (activeBuddiesPoints === "8") { points = data.total_points; label = "XP"; }

    return {
      value: points ? commaSeperator(points) : 0,
      label: t(label),
      rawPoints: points || 0
    };
  }

  // Helper function to extract raw points for sorting
  getRawPointsForSort = (data) => {
    const { activeBuddiesPoints } = this.props;
    if (activeBuddiesPoints === "1") return data.total_points || 0;
    if (activeBuddiesPoints === "2") return data.fitness_points || 0;
    if (activeBuddiesPoints === "3") return data.social_points || 0;
    if (activeBuddiesPoints === "4") return data.wellness_points || 0;
    if (activeBuddiesPoints === "9") return data.total_team_points || 0;
    if (activeBuddiesPoints === "8") return data.total_points || 0;
    return 0;
  }

  renderLeaderboardList = (dataList) => {
    const { t, activeBuddiesPoints } = this.props;
    const isTeamTab = activeBuddiesPoints === "9";
    const isMyTeamTab = activeBuddiesPoints === "8";

    // Header Titles based on tab
    let nameColumnTitle = t("Buddy");
    if (isTeamTab) nameColumnTitle = t("Team");
    if (isMyTeamTab) nameColumnTitle = t("Teammate name");


    const sortedList = [...dataList].sort((a, b) => {
      const pointsA = this.getRawPointsForSort(a);
      const pointsB = this.getRawPointsForSort(b);
      
      // Primary Sort: Points (High to Low)
      if (pointsB !== pointsA) {
        return pointsB - pointsA;
      }
      
      // Secondary Sort: Name (A to Z) for ties (including 0 points)
      const nameA = a.name || a.fullname || "";
      const nameB = b.name || b.fullname || "";
      return nameA.localeCompare(nameB);
    });
    // -----------------------------------------------------------

    return (
      <div style={{ width: '100%', marginTop: '20px' }}>
        {/* Table Header */}
        <LeaderboardHeader>
          <UserColumn style={{ paddingLeft: '20px' }}>{nameColumnTitle}</UserColumn>
          {/* Keep header left aligned with left padding */}
          <AnswerColumn style={{ textAlign: 'left', paddingRight: '40px' }}>{t("Points")}</AnswerColumn>
          <RankColumn style={{ width: "auto", textAlign: 'left', paddingRight: '20px' }}>{t("Ranks")}</RankColumn>
        </LeaderboardHeader>

        {/* Data Rows */}
        {sortedList.map((item, index) => {
          const rank = index + 1;
          const pointData = this.getPointsAndLabel(item);
          const rankSuffix = rank === 1 ? "st" : rank === 2 ? "nd" : rank === 3 ? "rd" : "th";
          
          let styleConfig = RANK_STYLES.default;
          let rankDisplay = (
            <>
              <span>{rank}{rankSuffix}</span>
              <span style={{ fontWeight: '400' }}> &nbsp;{t("Rank")}</span>
            </>
          );

          // Check if points are 0 (which sets Rank to N/A)
          const isZeroData = pointData.rawPoints === 0;

          // Conditional Style: Add padding right 45px only if points are 0/NA
          const paddingStyle = isZeroData ? { paddingRight: '48px' } : {};

          if (isZeroData) {
            styleConfig = RANK_STYLES.default;
            rankDisplay = <span>N/A</span>;
          } else if (RANK_STYLES[rank]) {
            styleConfig = RANK_STYLES[rank];
          }

          return (
            <LeaderboardRow
              key={index}
              style={{
                background: styleConfig.background,
                border: styleConfig.border,
                color: styleConfig.color,
                marginBottom: '10px',
                borderRadius: '8px',
                padding: '10px 0',
                alignItems: 'center',
                minHeight: '60px'
              }}
            >
              {/* User/Team Name & Image */}
              <UserColumn style={{ paddingLeft: '20px', display: 'flex', alignItems: 'center' }}>
                <div style={{ position: 'relative', width: '48px', height: '48px' }}>
                  {isMyTeamTab && item.is_captain === 1 && (
                    <CaptainLogoV2 src='/public/images/captain-band.png' style={{ position: 'absolute', top: '-10px', left: '-10px', width: '20px', zIndex: 2 }} />
                  )}
                  <LazyImage
                    style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: 'cover' }}
                    onError={this.fallBack}
                    src={`${ImageUrl}/${item.profile_image || item.logo || ""}`}
                    alt="Profile"
                  />
                </div>
                <NewUserName style={{ marginLeft: "20px", fontWeight: '600', fontSize: '16px', color: '#184A61' }}>
                  {item.name || item.fullname || `Team ${rank}`}
                </NewUserName>
              </UserColumn>

              {/* Points - Left Aligned + Conditional Right Padding for 0/NA */}
              <AnswerColumn style={{ textAlign: 'left', paddingRight: '40px', fontWeight: '500', color: '#184A61', ...paddingStyle }}>
                {pointData.value} {pointData.label}
              </AnswerColumn>

              {/* Rank - Left Aligned + Conditional Right Padding for 0/NA */}
              <RankColumn style={{ width: "auto", textAlign: 'left', paddingRight: '20px', color: '#184A61', ...paddingStyle }}>
                {rankDisplay}
              </RankColumn>
            </LeaderboardRow>
          );
        })}
      </div>
    );
  }


  renderMyTeamSection = (teamData) => {
    const { t } = this.props;
    const currentTeam = teamData[0]; 

    if (!currentTeam) {
      return <h1 style={{ textAlign: 'center', fontSize:'16px',color: '#184A61', fontFamily: 'lato', marginTop: '50px' }}>{t("You are not a member of any team.")}</h1>;
    }

    const rankSuffix = currentTeam.user_rank === 1 ? "st" : currentTeam.user_rank === 2 ? "nd" : currentTeam.user_rank === 3 ? "rd" : "th";
    const rankDisplay = currentTeam.total_team_points === 0 ? "N/A" : `${currentTeam.user_rank}${rankSuffix}`;

    return (
      
      <div style={{ width: '100%' }}>
        {/* Header with Title and Rank */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <Heading style={{ fontSize: '24px', color: '#184A61', fontWeight: 'bold' }}>{t("Overall Team Position")}</Heading>
          <div style={{ fontSize: '18px', color: '#184A61', fontWeight: 'bold',marginBottom: '20px' }}>{t("Rank")}: {rankDisplay}</div>
        </div>

        {/* Overall Team Position Card */}
        <OverallTeamPosition style={{ padding: '16px', background: '#FEFEFE', borderRadius: '12px', border: '0.75px solid #DCDCDC', marginBottom: '20px',height:'auto' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* Team Logo (Left) */}
            <div style={{ marginRight: '20px' }}>
              <img
                src={currentTeam.logo ? `${ImageUrl}/${currentTeam.logo}` : '/public/images/team-iconn.png'}
                style={{ width: '63px', height: '60px' }}
                alt="Team Logo"
              />
            </div>

            {/* Team Details (Right) - List Layout */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {/* Row 1: Team Name */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: '#184A61' }}>{t("Team Name")}</span>
                <span style={{ fontSize: '18px', fontWeight: '700', color: '#184A61' }}>{currentTeam.name}</span>
              </div>

              {/* Row 2: Slogan */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: '#184A61' }}>{t("Slogan")}</span>
                <span style={{ fontSize: '18px', fontWeight: '700', color: '#184A61' }}>{currentTeam.slogan || "-"}</span>
              </div>

              {/* Row 3: Team Contribution */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '16px', color: '#184A61', marginRight: '5px' }}>{t("Team Contribution")}</span>
                  {currentTeam.is_user_captain === 1 && (
                    <button onClick={this.showTeamDetails} style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '0', display: 'flex' }}>
                      <img src='/public/images/editiconn.png' style={{ width: '14px' }} alt="Edit" />
                    </button>
                  )}
                </div>
                <span style={{ fontSize: '18px', fontWeight: '700', color: '#184A61' }}>
                  {commaSeperator(currentTeam.total_team_points)} <span style={{ fontSize: '16px', fontWeight: '700' }}>XP</span>
                </span>
              </div>
            </div>
          </div>
        </OverallTeamPosition>

        {/* My Team Contribution List */}
        <Heading style={{ fontSize: '24px', color: '#184A61', fontWeight: '700', marginBottom: '20px', paddingTop:'20px'}}>{t("My Team Contribution")}</Heading>

        {currentTeam.team_users && currentTeam.team_users.length > 0 &&
          this.renderLeaderboardList(currentTeam.team_users)
        }
      </div>
    );
  }

  renderTitle = () => {
    const { activeBuddiesPoints, t } = this.props;
    let title = "";
    switch (activeBuddiesPoints) {
    case "1": title = t("Top Buddies Total Points"); break;
    case "2": title = t("Top Buddies Fitness Points"); break;
    case "3": title = t("Top Buddies Social Points"); break;
    case "4": title = t("Top Buddies Wellness Points"); break;
    case "9": title = t("Top Teams"); break;
    default: return null;
    }
    return <Heading style={{ fontSize: '24px', fontWeight: '700', color: '#184A61', marginBottom: '20px', lineHeight:'30px' ,height:'46px' }}>{title}</Heading>;
  }

  render() {
    const {

      socialUserData, fitnessUserData, wellnessUserData, topUsersTotalPoints,
      activeBuddiesPoints, companyTeamPoints, teamUsersPoints, teamIconsData
    } = this.props;

    // Loading State
    const isLoading =
      (activeBuddiesPoints === "1" && isEmpty(topUsersTotalPoints)) ||
      (activeBuddiesPoints === "2" && isEmpty(fitnessUserData)) ||
      (activeBuddiesPoints === "3" && isEmpty(socialUserData)) ||
      (activeBuddiesPoints === "4" && isEmpty(wellnessUserData)) ||
      (activeBuddiesPoints === "9" && isEmpty(companyTeamPoints)) ||
      (activeBuddiesPoints === "8" && isEmpty(teamUsersPoints));

    if (isLoading) {
      return (
        <div style={{ width: '100%', padding: '20px' }}>
          <SkeletonLoder width={"100%"} height={"355px"} style={{ borderRadius: '16px' }} />
          <SkeletonLoder width={"100%"} height={"80px"} style={{ margin: '15px 0px 10px 0px' }} />
          <SkeletonLoder width={"100%"} height={"80px"} />
        </div>
      );
    }

    // Determine data source
    let dataList = [];
    if (activeBuddiesPoints === "1") dataList = topUsersTotalPoints;
    else if (activeBuddiesPoints === "2") dataList = fitnessUserData;
    else if (activeBuddiesPoints === "3") dataList = socialUserData;
    else if (activeBuddiesPoints === "4") dataList = wellnessUserData;
    else if (activeBuddiesPoints === "9") dataList = companyTeamPoints;

    return (
      <React.Fragment>
        <CardWrapper onScroll={this.onScroll}>
          {activeBuddiesPoints !== "8" && (
            <div style={{ marginBottom: '10px' }}>
              {this.renderTitle()}
            </div>
          )}

          {activeBuddiesPoints === "8" ?
            this.renderMyTeamSection(teamUsersPoints) :
            this.renderLeaderboardList(dataList)
          }
        </CardWrapper>

        {this.state.showTeam && (
          <React.Suspense fallback={<div />}>
            <TeamDetailsPopup
              show={this.state.showTeam}
              hideModal={this.showTeamDetails}
              teamUsersPoints={teamUsersPoints}
              teamIconsData={teamIconsData[0]}
            />
          </React.Suspense>
        )}

        {this.SeeAllModal()}
      </React.Fragment>
    );
  }
}

BuddiesData.propTypes = {
  history: PropTypes.object.isRequired,
  fitnessLeaderboard: PropTypes.object,
  wellnessUserData: PropTypes.object,
  fitnessUserData: PropTypes.object,
  socialUserData: PropTypes.object,
  topUsersTotalPoints: PropTypes.object,
  companyTeamPoints: PropTypes.object,
  teamUsersPoints: PropTypes.array,
  teamIconsData: PropTypes.array,
  activeBuddiesPoints: PropTypes.string,
  leaderboardLimit: PropTypes.func,
  pageNumber: PropTypes.number,
  getTopSocialUsers: PropTypes.func,
  getTopFitnessUsers: PropTypes.func,
  getTopWellnessUsers: PropTypes.func,
  getTopUserTotalPoints: PropTypes.func,
  getCompanyTotalTeamPoints: PropTypes.func,
  getTotalTeamUsersPoints: PropTypes.func,
  companyId: PropTypes.number,
  userLimit: PropTypes.number,
  updateLimit: PropTypes.func,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  teamUsersPoints: state.companyDashboard.teamUsersPoints,
  companyTeamPoints: state.companyDashboard.companyTeamPoints,
});

export default connect(mapStateToProps, null)(withTranslation()(BuddiesData));